import type { AccessUser, JobConfig, UserRole } from "@cv-screener/shared";

const roleOrder: Record<UserRole, number> = {
  SuperAdmin: 0,
  Admin: 1,
  Recruiter: 2,
  Viewer: 3,
};

function jobAccess(entry: AccessUser, jobs: JobConfig[]): { tier: number; assignedCount: number } {
  const assignedCount = jobs.filter((job) => entry.assignedJobIds.includes(job.jobId)).length;
  const allJobs = entry.role === "SuperAdmin"
    || (jobs.length > 0 && ((entry.role === "Admin" && entry.assignedJobIds.length === 0) || assignedCount === jobs.length));
  return { tier: allJobs ? 0 : assignedCount > 0 ? 1 : 2, assignedCount };
}

export function compareAccessUsers(left: AccessUser, right: AccessUser, jobs: JobConfig[]): number {
  if (left.enabled !== right.enabled) return left.enabled ? -1 : 1;
  const roleDifference = roleOrder[left.role] - roleOrder[right.role];
  if (roleDifference !== 0) return roleDifference;
  const leftAccess = jobAccess(left, jobs);
  const rightAccess = jobAccess(right, jobs);
  if (leftAccess.tier !== rightAccess.tier) return leftAccess.tier - rightAccess.tier;
  if (leftAccess.assignedCount !== rightAccess.assignedCount) return rightAccess.assignedCount - leftAccess.assignedCount;
  return left.displayName.localeCompare(right.displayName) || left.email.localeCompare(right.email);
}
